/**
 * Regra única de quais clínicas da role aparecem no modal e nos selects.
 *
 * A role sai da lista só em dois casos: convite pendente, ou Organization
 * encontrada com active === false. organizationList começa undefined e a
 * busca socio não usa os references das roles. Enquanto a lista não chega,
 * ou se a busca não devolve o id, o vínculo da role continua visível.
 */

export type ClinicOrganizationEntry = {
  resource?: {
    id?: string;
    active?: boolean;
    name?: string;
    alias?: Array<string | undefined>;
  };
};

export type ClinicRoleOption = {
  isInvited?: boolean;
  organization?: {
    reference?: string;
    display?: string;
  };
};

function findClinicOrganization(
  role: ClinicRoleOption | undefined,
  organizationList: ClinicOrganizationEntry[] | undefined
) {
  const referenceId = role?.organization?.reference?.split("/")[1];
  return organizationList?.find((entry) => entry?.resource?.id === referenceId);
}

export function isVisibleClinicRole(
  role: ClinicRoleOption | undefined,
  organizationList: ClinicOrganizationEntry[] | undefined
) {
  if (role?.isInvited) return false;
  const organization = findClinicOrganization(role, organizationList);
  if (organization?.resource?.active === false) return false;
  return true;
}

/** Alias só entra se existir e não for a string "null". Senão name, display da role, ou "-". */
export function clinicLabel(
  role: ClinicRoleOption | undefined,
  organizationList: ClinicOrganizationEntry[] | undefined
) {
  const organization = findClinicOrganization(role, organizationList);
  const alias = organization?.resource?.alias?.[0];
  if (alias && alias !== "null") return alias;
  return organization?.resource?.name || role?.organization?.display || "-";
}
